// Components
import iconImage from "src/app/assets/logo.png";
import OptIn, { setCookie } from "../components/OptIn";
import { Link } from "react-router-dom";
// Styles
import { ThemeProvider, createStyles, createTheme, makeStyles } from "@material-ui/core";
import { Wrapper } from "../App.styles";

const theme = createTheme({
  palette: {
    primary: {
      main: "#D13E3A",
    },
    secondary: {
      main: "#44599e",
    },
    text: {
      primary: "#201d1e",
    },
  },
});

const bannerText: any = {
  style: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    padding: "15px",
    fontFamily: "Georgia, serif",
    background: "#201d1e",
    WebkitBackgroundClip: "text",
    WebkitTextFillColor: "transparent",
    fontSize: "50px",
  },
};

export default function Home() {
  const useStyles = makeStyles((theme: any) =>
    createStyles({
      background: {
        width: "100%",
        maxWidth: "824px",
        height: "80vh",
        maxHeight: "810px",
        display: "flex",
        justifyContent: "center",
        backgroundSize: "100% auto",
        backgroundPosition: "center",
        background: "no-repeat",
        backgroundImage: `url(${iconImage})`,
      },
      footer: {
        display: "flex",
        padding: "20px",
        textAlign: "center",
        flexDirection: "column",
      },
      a: {
        color: "#007bff",
        textDecoration: "underline",
      },
    })
  );

  const handleOpenOptIn = () => {
    setCookie("temp_opt");
    window.location.reload();
  };

  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <Wrapper>
        <div className={classes.background}>
          <OptIn />
        </div>
      </Wrapper>
      <footer className={classes.footer}>
        <Link to="/privacy">Privacy Policy</Link>
        <a className={classes.a} onClick={() => handleOpenOptIn()}>
          Customer Opt-in
        </a>
      </footer>
    </ThemeProvider>
  );
}
